import React, { useEffect, useState } from "react";
import ReactEcharts, { EChartsOption } from "echarts-for-react";
import {
  DashboardVars,
  GetDashboardTicketCountData,
  GetDashboardTicketPriorityCountData
} from "../../types";
import { GetDashboardTicketPriorityCount } from "../../queries";

import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../../customHooks/useLoggedInUserDetails";
import { useLazyQuery } from "@apollo/client";
import { TEXT_FONT_FAMILY } from "../../../../../../../styles/Variables";

const TicketDetailsGraph = () => {

  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [GetDashboardTickets, { data, loading, fetchMore }] = useLazyQuery<
    GetDashboardTicketPriorityCountData,
    DashboardVars
  >(GetDashboardTicketPriorityCount);
  useEffect(() => {
    if (customer_id || user_details.id) {
      GetDashboardTickets({
        variables: {
     
          customerID: customer_id ? customer_id : 0,
          empID: user_details.id ? user_details.id : 0
        }
      });
    }
  }, [customer_id, user_details.id, GetDashboardTickets]);

  const [gaugeData, setGaugeData] = useState([
    {
      value: 0,
      name: "Critical",
      title: { offsetCenter: ["0%", "-30%"] },
      detail: { valueAnimation: true, offsetCenter: ["0%", "-20%"] }
    },
    {
      value: 0,
      name: "Medium",
      title: { offsetCenter: ["0%", "0%"] },
      detail: { valueAnimation: true, offsetCenter: ["0%", "10%"] }
    },
    {
      value: 0,
      name: "Low",
      title: { offsetCenter: ["0%", "30%"] },
      detail: { valueAnimation: true, offsetCenter: ["0%", "40%"] }
    }
  ]);
  useEffect(() => {
    const updatedGaugeData = gaugeData.map((item) => {
      let color = "";
      if (item.name === "Critical") color = "#dc2626";
      else if (item.name === "Medium") color = "#d97706";
      else if (item.name === "Low") color = "#16a34a";

      return {
        ...item,
        itemStyle: { color },
        progress: { itemStyle: { color } }
      };
    });
    setGaugeData(updatedGaugeData);
  }, []);
  useEffect(() => {
    if (data && data.GetDashboardTicketPriorityCount) {
      const updatedData = gaugeData.map((item) => ({
        ...item,
        value:
          data.GetDashboardTicketPriorityCount.find((d) => d.desc === item.name)
            ?.count || 0
      }));
      setGaugeData(updatedData);
    }
  }, [data]);

  const option: EChartsOption = {
    series: [
      {
        type: "gauge",
        startAngle: 90,
        endAngle: -270,
        pointer: { show: false },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            borderWidth: 1,
            borderColor: "#f3f4f6"
          }
        },
        axisLine: { lineStyle: { width: 25 } },
        splitLine: { show: false, distance: 0, length: 10 },
        axisTick: { show: false },
        axisLabel: { show: false, distance: 30 },
        data: gaugeData,
        title: { show: false },
        detail: {
          // width: 30,
          // height: 2,
          // fontSize: 6,
          // color: 'inherit',
          // borderColor: 'inherit',
          // borderRadius: 10,
          // borderWidth: 1,
          // formatter: '{value}%'
          show: false
        }
      }
    ],
    legend: {
      show: true
    },
    tooltip: {
      show: true,
      textStyle: {
        fontSize: 12,
        fontFamily: TEXT_FONT_FAMILY,
        fontWeight: 600
      }
    }
  };

  return (
    <div className="d-ticket-details__graph">
      <b className="d-main-page__block--title">Priority Tickets</b>
      <ReactEcharts option={option} />
    </div>
  );
};

export default TicketDetailsGraph;
